'use client'

import { AlertDialog } from '@macarongfactory/web-ui'
import { overlay } from 'overlay-kit'

import { getBrowserType } from '@/shared/lib'
import { getPlatform } from '@/shared/lib/appBridge/appBridge.utils'

const DIALOG_TITLE = '위치 권한을 허용해주세요'

const DIALOG_DESCRIPTION = {
  /** 기타 브라우저 (NAVER · Firefox 등) */
  default:
    '내 주변 정비소를 보기 위해 위치 권한이 필요해요. 설정에서 권한을 허용해주세요.',
  /** Chrome 웹 */
  chrome:
    '내 주변 정비소를 보기 위해 위치 권한이 필요해요. [설정 > 사이트 설정 > 위치]에서 권한을 허용해주세요.',
  /** Safari 웹 */
  safari:
    '내 주변 정비소를 보기 위해 위치 권한이 필요해요. [메뉴 > 위치]에서 권한을 허용해주세요.',
} as const

type TDescriptionKey = keyof typeof DIALOG_DESCRIPTION

/** 브라우저별 안내 문구 키 결정 */
const resolveDescriptionKey = (): TDescriptionKey => {
  const browserType = getBrowserType()
  if (browserType === 'chrome') return 'chrome'
  if (browserType === 'safari') return 'safari'
  return 'default'
}

const useLocationPermissionDialog = () => {
  const open = () => {
    // 앱 WebView 에서는 네이티브가 권한 거부 다이얼로그를 직접 띄우므로 웹은 무동작
    if (getPlatform() !== null) return

    const description = DIALOG_DESCRIPTION[resolveDescriptionKey()]

    overlay.open(({ isOpen, close }) => (
      <AlertDialog open={isOpen} onClose={close}>
        <AlertDialog.Header title={DIALOG_TITLE} description={description} />
        <AlertDialog.Bottom.TextButton text='확인' clickable={close} />
      </AlertDialog>
    ))
  }

  return { open }
}

export default useLocationPermissionDialog
